{
  "loading": "Ładowanie...",
  "loadingMore": "Wczytywanie większej liczby..."
}
